import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpResponse } from '@angular/common/http';
import { filter, map, Observable, tap } from 'rxjs';

const basePath = '/api/files';

@Injectable({ providedIn: 'root' })
export class ImageClient {
    private readonly _client = inject(HttpClient);

    upload(file: File | Blob, onProgress?: (progress: number) => void): Observable<string> {
        const formData = new FormData();
        formData.append('', file);
        return this._client
            .post(basePath, formData, {
                observe: 'events',
                reportProgress: true,
                responseType: 'text',
            })
            .pipe(
                tap(event => {
                    if (event.type !== HttpEventType.UploadProgress || !event.total) return;

                    onProgress?.(Math.round((event.loaded * 100) / event.total));
                }),
                filter((event): event is HttpResponse<string> => event.type === HttpEventType.Response),
                map(event => event.body ?? '')
            );
    }
}
